import { NAVIGATION_V2, SIDEBAR } from 'src/modules/constants';
import { ModulesList } from 'src/modules/types';
import SidebarModule from './index';
import NavigationV2 from './navigationV2';

const module: ModulesList = {
  [SIDEBAR]: {
    component: SidebarModule,
  },
  [NAVIGATION_V2]: {
    component: NavigationV2,
  },
};

export default module;
